export const getStoredAdminPermissions = () => {
  const storedPerms = JSON.parse(localStorage.getItem("userPermissions") || "[]") || [];
  const fallbackPerms = (JSON.parse(localStorage.getItem("adminData") || "{}")?.permissions) || [];
  return storedPerms.length ? storedPerms : fallbackPerms;
};

export const getFirstAccessibleAdminPath = (admin, permissions = []) => {
  const normalizedRole = String(admin?.role || "").toLowerCase().replace(/\s+/g, "");
  const hasAllAccess = permissions.includes("ALL") || permissions.includes("all");
  const isFullAccessRole = ["mainadmin", "superadmin", "root"].includes(normalizedRole);

  if (hasAllAccess || isFullAccessRole) {
    return "/Dashboard";
  }

  const permissionRoutes = [
    { permission: "Dashboard_View", path: "/Dashboard" },
    { permission: "Master_View", path: "/DepartmentList" },
    { permission: "Employee_View", path: "/EmployeeList" },
    { permission: "Leave_Management_View", path: "/LeaveHistory" },
    { permission: "Shift_Management_view", path: "/ShiftManagement" },
    { permission: "Attendance_history_view", path: "/EmployeeAttendanceHistory" },
    { permission: "Pay_slip_view", path: "/GenerateAllEmployeePayslip" },
    { permission: "Admin_Management_view", path: "/AdminManagement" },
    { permission: "Activity_History_view", path: "/ActivityHistory" },
  ];

  const firstMatch = permissionRoutes.find((item) => permissions.includes(item.permission));
  return firstMatch?.path || "/";
};
